<script setup>
import { computed } from 'vue'
import Modal from '@/Components/Modal.vue'
import SupportEnquiryForm from '@/Components/SupportEnquiryForm.vue'
import ButtonCta from '@/Components/ui/buttons/ButtonCta.vue'
import { useGetInTouch } from '@/Stores/getintouch'

defineProps({
	show: {
		type: Boolean,
		default: false,
	},
	maxWidth: {
		type: String,
		default: 'md',
	},
	closeable: {
		type: Boolean,
		default: true,
	},
})

const getInTouch = useGetInTouch()

const isSubmitted = computed(() => {
	return getInTouch.getIsSubmitted
})

const emit = defineEmits(['close'])

function close() {
	emit('close')
}
</script>

<template>
	<Modal
		:show="show"
		:max-width="maxWidth"
		:overflow-hidden="false"
		:closeable="closeable"
		@close="close"
	>
		<div class="">
			<div class="px-6 pt-8 pb-6">
				<div v-if="!isSubmitted" class="text-lg font-medium">
					<h2 class="text-idrive-dark">
						Still deciding? We're here to help!
					</h2>
					<p class="mt-4 leading-tight text-idrive-dark">
						Book directly through our website and enjoy
						<span class="underline underline-offset-2 font-bold">
							10%
						</span>
						off your booking.
					</p>
					<p class="mt-4 leading-tight text-idrive-dark">
						Fill up the form below and we will get back to you as
						soon as possible. Have questions? Our team is just a
						message away.
					</p>
				</div>
				<div v-else>
					<div class="text-center">
						<h2 class="text-idrive-dark">Thank you</h2>
						<div class="flex flex-col gap-2 mt-4">
							<p class="leading-tight font-semibold">
								Your submission has been received.
							</p>
							<p class="text-sm">
								One of our representatives will reach out to you
								shortly.
							</p>
							<div class="mx-auto mt-4">
								<ButtonCta type="submit" button-mode="dark">
									<div
										class="flex items-center font-bold"
										@click="close"
									>
										Close
									</div>
								</ButtonCta>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div
				v-if="!isSubmitted"
				class="px-6 pt-6 pb-8 bg-white rounded-b-lg"
			>
				<SupportEnquiryForm />
			</div>
		</div>
	</Modal>
</template>
